import React from 'react';
import styled from 'styled-components';

import WP from 'WP';

import GridElement from 'partials/GridElement';

import Media from 'css/Media';

const SuccessForm = props => {
    return (
        <FormGrid id="form">
            <TitleGridElement
                colStart={{default: 1, s: 3, m: 3}}
                colEnd={{default: 8, s: 14, m: 14}}
                rowStart={1}
            >
                <h4>{WP.trans.reservationConfirmation}</h4>
            </TitleGridElement>
        </FormGrid>
    )
}


export default SuccessForm;

const FormGrid = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (1fr .359fr)[3] 1fr;
    grid-template-columns: repeat(3, 1fr .359fr) 1fr;
    -ms-grid-rows: ${props => props.rows || 'auto'};
    grid-template-rows: ${props => props.rows || 'auto'};
    margin-bottom: ${props => props.theme.spacing.elementM};

    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .67fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .67fr) 1fr;
        padding: ${props => props.theme.spacing.elementL} 0 ${props => props.theme.spacing.blockM};
        margin-bottom: ${props => props.theme.spacing.blockL};
        border: 1px solid ${props => props.theme.colors.text};
    `}

    ${Media.greaterThan('m')`
        -ms-grid-columns: (1fr .435fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .435fr) 1fr;
    `}
`

const TitleGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.contentXL};
    `}
`